module.exports = __webpack_public_path__ + "static/media/photo-10-sm.798e33cc.jpeg";